import React from 'react';
import {withRouter} from 'react-router-dom';
import Select from 'react-select';
import {compose} from 'recompose';

import {translate} from 'iss/strings';
import {createContractSupplierReview, getOwnContractSupplierReview, modifyContractSupplierReview} from 'iss/service/ContractSupplierReviewService';
import {getContractSupplier} from 'iss/service/ContractSuppliersService';
import styles from 'iss/styles/ContractSupplierEditor.styl';
import subscribeTo from 'iss/utils/subscriptionUtils';
import {Button, CancelButton, SubmitButton} from 'iss/widgets/Buttons';
import {FormWithState, Input} from 'iss/widgets/Forms';
import {RestResultMessage, SuccessBox} from 'iss/widgets/MessageBox';

const ContractSupplierReviewEditor = compose(
  withRouter,
  subscribeTo(({supplierId}) => getOwnContractSupplierReview(supplierId), "review"),
  subscribeTo(({supplierId}) => getContractSupplier(supplierId), "supplier"),

)(class ContractSupplierReviewEditor extends React.Component {

  isNew = () => {
    return this.props.review.id === null;
  };

  red = "red";
  gray = "lightgray";

  state = {
    backendError: null,
    grade: this.props.review.grade,
    selectBorderColor: this.gray,
    additionalInformationLength: 0,
  };

  handleSelection = (selectedGrade) => {
    this.setState({ grade: selectedGrade.value, selectBorderColor: this.gray});
  };

  saveReview = ({additionalInformation}) => {
    if (this.state.grade === null) {
      this.setState({selectBorderColor: this.red});
    } else {
      let info = additionalInformation == null ? "" : additionalInformation;
      if (this.isNew()) {
        const data = {
          grade: this.state.grade,
          additionalInformation: info,
          contractSupplierId: this.props.supplier.id,
        };
        createContractSupplierReview(data).subscribe(() => {
          this.props.history.push(
            "/contract-supplier/"+this.props.supplier.id+"/reviews/new?success=true"
          );
        },
        (errorResponse) => this.setState({backendError: errorResponse}));
      } else {
        const data = {
          grade: this.state.grade,
          additionalInformation: info
        };
        modifyContractSupplierReview(this.props.review.id, data).subscribe(() => {
          this.props.history.push(
            "/contract-supplier/"+this.props.supplier.id+"/reviews/new?success=true"
          );
        },
        (errorResponse) => this.setState({backendError: errorResponse}));
      }
    }
  };

  render() {
    const showSuccessMessage = this.props.history.location.search.indexOf("success=true") != -1;
    const { grade, selectBorderColor } = this.state;
    const {supplier, review} = this.props;
    const gradeOptions = [
      {value: 1, label: 1},
      {value: 2, label: 2},
      {value: 3, label: 3},
      {value: 4, label: 4},
      {value: 5, label: 5}
    ];
    return <FormWithState initialValues={review} className="tight-form-controls" onSubmit={this.saveReview}>

            <SuccessBox id="submitSuccess" message={showSuccessMessage ? translate('common.savedSuccessfully') : null} />

            <h4>
              {translate('contractSupplierReviewEditor.contractSupplier') + ": " + supplier.name}
            </h4>
            <h1>{
                this.isNew() ?
                translate('contractSupplierReviewEditor.newTitle') :
                translate('contractSupplierReviewEditor.modifyTitle')
            }</h1>

            <Button
              id="to-supplier"
              link={"/contract-supplier/"+supplier.id}
              text={translate('contractSupplierReviewEditor.returnToSupplier')}
              className={styles.rightFloatButton}
            />
            <br/>
            <br/>
            <br/>
            <Select
              id="grade-select"
              options={gradeOptions}
              onChange={this.handleSelection}
              value={grade == null ? null : {value: grade, label: grade}}
              placeholder={translate('domain.contractSupplierReview.grade')}
              isClearable={false}
              style={{borderColor: selectBorderColor}}
            />
            <br/>
            <Input
              label="domain.contractSupplierReview.additionalInformation"
              id="review-additionalInformation"
              valuePath="additionalInformation"
              maxLength="1000"
              showCounter={true}
            />
            <br/>

            <RestResultMessage id="backendError" result={this.state.backendError} />

            <div className="form-supplier">
                <SubmitButton id="save-review" text={translate('common.save')} />
                <CancelButton id="cancel" link={"/contract-supplier/"+supplier.id} />
            </div>

        </FormWithState>;
  }
});

export default ContractSupplierReviewEditor;



// WEBPACK FOOTER //
// ./modules/issFrontend/pages/ContractSupplierReviewEditor.jsx